import { PromoBannerType } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/bannerOrder";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { usePromoBanners } from "@faire/retailer-visitor-shared/stores/ui/usePromoBanners";
import { useEffect } from "react";

/**
 * TODO: This hook isn't needed anymore.
 * We should remove it and just use the promo banners from the MarketStore directly.
 */
export const useSynchronizePromoBanners = () => {
  const { banners } = usePromoBanners();
  const { setHasMarketCountdownBanner } = useMarketStore();

  useEffect(() => {
    setHasMarketCountdownBanner(
      banners && banners[0] === PromoBannerType.MARKET_COUNTDOWN
    );
  }, [banners, setHasMarketCountdownBanner]);

  return null;
};
